import React, { useCallback, useEffect, useState } from 'react';
import { ScrollView, View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { Modal } from '@material-ui/core';
import { Close, ArrowDropDown, FilterList, DateRange, Sort } from '@material-ui/icons';
import ajax from '../../../../../helpers/ajaxHelper';
import Urls from '../../../../../services/Urls';
import { showErrorToast, showSuccesToast } from '../../helpers';

const ActivityTimelineModal = ({ isVisible, onClose,flowId }) => {
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [showAlphaFilter, setShowAlphaFilter] = useState(false);
  const [dateFilter, setDateFilter] = useState('all');
  const [alphaFilter, setAlphaFilter] = useState('title-asc');
  const [activities, setActivities] = useState([]);
  const [total, setTotal] = useState(0)
  const [page, setPage] = useState(1)

  useEffect(() => {
    if(isVisible){
      fetchTableData()
    }

}, [page,isVisible])
const fetchTableData = useCallback(async () => {
  try {
    const limit = 30;
    const filters = { 
      offset: page - 1, 
      pageNo: page - 1, 
      limit: limit, 
      pageSize: limit, 
      sortOrder: "asc" 
    };
    const { data } = await ajax.get(`${Urls.getLogs}?flow_id=${flowId}`, { params: filters });
    
    console.log("getLogs", data);
    
    if (data.status) {
      const rawActivities = data?.data?.data || [];
      const newActivities = rawActivities.map(item => {
        let dateStr = item.date;
        let timeStr = item.time;
        let dt = null;

        // Try to parse standard timestamps if date isn't provided or isn't in DD/MM/YYYY format
        if (!dateStr && (item.created_at || item.createdAt || item.timestamp)) {
          dt = new Date(item.created_at || item.createdAt || item.timestamp);
        } else if (dateStr && (dateStr.includes('-') || dateStr.includes('T'))) {
          dt = new Date(dateStr);
        }

        if (dt && !isNaN(dt.getTime())) {
          dateStr = `${dt.getDate().toString().padStart(2, '0')}/${(dt.getMonth() + 1).toString().padStart(2, '0')}/${dt.getFullYear()}`;
          if (!timeStr) {
            timeStr = `${dt.getHours().toString().padStart(2, '0')}:${dt.getMinutes().toString().padStart(2, '0')}`;
          }
        }

        // Try to create a reliable numeric timestamp for sorting
        let timestampValue = dt ? dt.getTime() : 0;
        if (!timestampValue && dateStr && dateStr !== 'Unknown') {
          const [d, m, y] = dateStr.split('/');
          if (y && m && d) {
             timestampValue = new Date(`${y}-${m}-${d}T${timeStr || '00:00'}:00`).getTime();
          }
        }

        return {
          ...item,
          date: dateStr || 'Unknown',
          time: timeStr || '',
          _timestamp: timestampValue || 0
        };
      });
      
      setActivities(prev => {
        if (page === 1) return newActivities;
        return newActivities.length > 0 ? [...prev, ...newActivities] : prev;
      });
      
      const returnedCount = data?.data?.count;
      if (typeof returnedCount === 'number') {
         setTotal(returnedCount);
      } else {
         // Fallback: if backend doesn't provide total, assume there is another page if we hit the limit
         setTotal(newActivities.length === limit ? (page * limit) + 1 : activities.length + newActivities.length);
      }
    } else {
      showErrorToast(data.message);
    }
  } catch (err) {
    console.error(err);
    showErrorToast("Something went wrong!");
  }
}, [page, flowId]);
const downloadLogs = useCallback(async (type) => {
  const filters = {
    type: type,
    flow_id: flowId,
    style: "obx",
  }
  ajax.get(Urls.getLogsData+"?", { params: filters }).then(({ data }) => {
      console.log("getLogs", data)
      if (data.status) {
      if(data.data && typeof data.data == "string"){
        onClose()
        showSuccesToast("Logs Downloaded successfully!")
        const link = document.createElement('a');
        link.href = data.data;
        link.setAttribute('download', 'logs.'+type); // optional: forces download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      } else {
        onClose()
          showErrorToast(data?.message?data?.message:"Something went wrong!" )
      }
  }
  ).catch((err)=>{
    onClose()
          showErrorToast("Something went wrong!")
  })
}
)
  // Get unique dates for filtering
  const uniqueDates = [...new Set(activities.map(item => item?.date))].filter(Boolean).sort((a, b) => {
    const [aDay, aMonth, aYear] = String(a || '').split('/');
    const [bDay, bMonth, bYear] = String(b || '').split('/');
    return new Date(`${aYear}-${aMonth}-${aDay}`) - new Date(`${bYear}-${bMonth}-${bDay}`);
  });

  // Filter and sort activities
  const filteredActivities = activities
    .filter(activity => {
      if (!activity) return false;
      if (dateFilter === 'all') return true;
      return activity.date === dateFilter;
    })
    .sort((a, b) => {
      if (alphaFilter === 'title-asc') {
        return String(a?.title || '').localeCompare(String(b?.title || ''));
      } else if (alphaFilter === 'title-desc') {
        return String(b?.title || '').localeCompare(String(a?.title || ''));
      } else if (alphaFilter === 'date-desc') {
        return (b?._timestamp || 0) - (a?._timestamp || 0);
      } else { // date-asc
        return (a?._timestamp || 0) - (b?._timestamp || 0);
      }
    });

  const toggleDateFilter = () => {
    setShowDateFilter(!showDateFilter);
    setShowAlphaFilter(false);
  };

  const toggleAlphaFilter = () => {
    setShowAlphaFilter(!showAlphaFilter);
    setShowDateFilter(false);
  };

  const handleDateFilter = (date) => {
    setDateFilter(date);
    setShowDateFilter(false);
  };

  const handleAlphaFilter = (type) => {
    setAlphaFilter(type);
    setShowAlphaFilter(false);
  };

  return (
    <Modal open={isVisible} style={styles.modal}>
      <View style={styles.overlay}>
        <View style={styles.modalContainer}>
          <View style={styles.card}>
            {/* Header with close button */}
            <View style={styles.header}>
              <View>
                <Text style={styles.heading}>Activity Timeline</Text>
                <Text style={styles.subtitle}>{dateFilter === 'all' ? 'All activities' : `Showing activities for ${dateFilter}`}</Text>
              </View>
              <TouchableOpacity onPress={onClose} style={styles.closeButton}>
                <Close style={{ fontSize: 20, color: '#64748b' }} />
              </TouchableOpacity>
            </View>
            
            {/* Filter controls */}
            <View style={styles.filterControls}>
              <TouchableOpacity style={styles.filterBtn} onPress={toggleDateFilter}>
                <DateRange style={{ fontSize: 16, color: '#3b82f6', marginRight: 6 }} />
                <Text style={styles.filterBtnText}>Date</Text>
                <ArrowDropDown style={{ fontSize: 18, color: '#94a3b8', marginLeft: 4 }} />
              </TouchableOpacity>
              
              <TouchableOpacity style={styles.filterBtn} onPress={toggleAlphaFilter}>
                <Sort style={{ fontSize: 16, color: '#3b82f6', marginRight: 6 }} />
                <Text style={styles.filterBtnText}>
                  {alphaFilter === 'title-asc' ? 'Title (A-Z)' : 
                   alphaFilter === 'title-desc' ? 'Title (Z-A)' : 
                   alphaFilter === 'date-desc' ? 'Newest First' : 'Oldest First'}
                </Text>
                <ArrowDropDown style={{ fontSize: 18, color: '#94a3b8', marginLeft: 4 }} />
              </TouchableOpacity>
              <TouchableOpacity
              onPress={()=>{
                downloadLogs("pdf")
              }}
              style={styles.downloadBtn}>
                <Text style={styles.downloadBtnText}>PDF</Text>
              </TouchableOpacity>
              <TouchableOpacity 
               onPress={()=>{
                downloadLogs("csv")
              }}
              style={[styles.downloadBtn, { backgroundColor: '#4f46e5' }]}>
                <Text style={styles.downloadBtnText}>CSV</Text>
              </TouchableOpacity>
              <TouchableOpacity 
                style={[styles.filterBtn, styles.clearFilterBtn]} 
                onPress={() => {
                  setDateFilter('all');
                  setAlphaFilter('date-desc');
                }}
              >
                <Text style={[styles.filterBtnText, { color: '#ef4444' }]}>Clear Filters</Text>
              </TouchableOpacity>
            </View>
            
            {/* Dropdowns */}
            {showDateFilter && (
              <View style={styles.filterDropdown}>
                <TouchableOpacity 
                  style={styles.filterOption} 
                  onPress={() => handleDateFilter('all')}
                >
                  <Text style={styles.filterOptionText}>All Dates</Text>
                </TouchableOpacity>
                {uniqueDates.map(date => (
                  <TouchableOpacity 
                    key={date} 
                    style={styles.filterOption} 
                    onPress={() => handleDateFilter(date)}
                  >
                    <Text style={styles.filterOptionText}>{date}</Text>
                  </TouchableOpacity>
                ))}
              </View>
            )}
            
            {showAlphaFilter && (
              <View style={styles.filterDropdown}>
                <TouchableOpacity 
                  style={styles.filterOption} 
                  onPress={() => handleAlphaFilter('title-asc')}
                >
                  <Text style={styles.filterOptionText}>Title (A-Z)</Text>
                </TouchableOpacity>
                <TouchableOpacity 
                  style={styles.filterOption} 
                  onPress={() => handleAlphaFilter('title-desc')}
                >
                  <Text style={styles.filterOptionText}>Title (Z-A)</Text>
                </TouchableOpacity>
                <TouchableOpacity 
                  style={styles.filterOption} 
                  onPress={() => handleAlphaFilter('date-desc')}
                >
                  <Text style={styles.filterOptionText}>Newest First</Text>
                </TouchableOpacity>
                <TouchableOpacity 
                  style={styles.filterOption} 
                  onPress={() => handleAlphaFilter('date-asc')}
                >
                  <Text style={styles.filterOptionText}>Oldest First</Text>
                </TouchableOpacity>
              </View>
            )}

            {/* Timeline content */}
            <ScrollView style={styles.scrollContainer} showsVerticalScrollIndicator={false}>
              <View style={styles.timeline}>
                <View style={styles.verticalLine} />
                {filteredActivities &&filteredActivities.length?
                filteredActivities.map((item, index) => (
                  <View key={item?.id || `activity-${index}`} style={styles.item}>
                    <View style={styles.dotContainer}>
                      <View style={[styles.dot, styles[`dot-${item.category}`]]} />
                    </View>
                    <View style={styles.content}>
                      <View style={styles.titleRow}>
                        <Text style={[styles.itemTitle, styles[`title-${item.category}`]]}>
                          {item.title}
                        </Text>
                        <View style={styles.timeContainer}>
                          <Text style={styles.time}>{item.time}</Text>
                        </View>
                      </View>
                      <Text style={styles.description}>{item.description}</Text>
                      <View style={styles.metaRow}>
                        <View style={styles.avatar}>
                          <Text style={styles.avatarText}>{item.initials}</Text>
                        </View>
                        <Text style={styles.user}>
                          {typeof item?.user === 'object' && item?.user !== null 
                            ? `${item.user.first_name || ''} ${item.user.last_name || ''}`.trim() 
                            : item?.user}
                        </Text>
                        <Text style={styles.date}>{item.date}</Text>
                      </View>
                    </View>
                  </View>
                )):<>
                 <Text style={styles.NoloadMore}>No Activities found</Text>
                </>}
              </View>
            </ScrollView>

             {activities?.length >= total? null:<TouchableOpacity
             onPress={()=>{
              setPage(page+1)
             }}
             style={styles.loadMoreContainer}>
              <Text style={styles.loadMore}>Load More Activities</Text>
            </TouchableOpacity>}
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 10,
    paddingRight: 10,
    flex: 1,
    backgroundColor:"red"
  },
  overlay: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    padding: 16,

  },
  modalContainer: {
    backgroundColor: '#fff',
    borderRadius: 12,
    overflow: 'hidden',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 20,
    elevation: 5,
    width: '100%',
    maxWidth: 680,
    minHeight: '90vh',
  },
  card: {
    backgroundColor: '#fff',
    padding: 20,
    paddingBottom: 12,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 16,
  },
  heading: {
    fontSize: 22,
    fontWeight: '700',
    color: '#1e293b',
    letterSpacing: -0.3,
  },
  subtitle: {
    fontSize: 14,
    color: '#64748b',
    marginTop: 4,
  },
  closeButton: {
    padding: 4,
    marginTop: 2,
  },
  filterControls: {
    flexDirection: 'row',
    gap: 10,
    marginBottom: 18,
    flexWrap: 'wrap',
  },
  filterBtn: {
    backgroundColor: '#f1f5f9',
    paddingVertical: 8,
    paddingHorizontal: 14,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    borderWidth: 1,
    borderColor: '#e2e8f0',
  },
  clearFilterBtn: {
    backgroundColor: 'transparent',
    borderColor: '#fee2e2',
    marginLeft: 'auto',
  },
  filterBtnText: {
    color: '#334155',
    fontWeight: '600',
    fontSize: 13,
  },
  filterDropdown: {
    backgroundColor: '#fff',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#e2e8f0',
    padding: 8,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 2,
  },
  filterOption: {
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderRadius: 6,
  },
  filterOptionText: {
    fontSize: 14,
    color: '#334155',
  },
  scrollContainer: {
    minHeight: '65vh',
    maxHeight: '50vh',
    marginBottom: 8,
  },
  timeline: {
    position: 'relative',
    paddingLeft: 20,
  },
  verticalLine: {
    position: 'absolute',
    left: 25,
    top: 0,
    bottom: 0,
    width: 1.5,
    backgroundColor: '#e2e8f0',
  },
  item: {
    flexDirection: 'row',
    marginBottom: 16,
    position: 'relative',
  },
  dotContainer: {
    width: 30,
    alignItems: 'center',
    paddingTop: 5,
  },
  dot: {
    width: 14,
    height: 14,
    borderRadius: 7,
    borderWidth: 2,
    borderColor: '#fff',
    zIndex: 1,
  },
  'dot-system': {
    backgroundColor: '#3b82f6',
  },
  'dot-tenant': {
    backgroundColor: '#8b5cf6',
  },
  'dot-payment': {
    backgroundColor: '#10b981',
  },
  'dot-document': {
    backgroundColor: '#f59e0b',
  },
  'dot-notification': {
    backgroundColor: '#ef4444',
  },
  content: {
    flex: 1,
    backgroundColor: '#f8fafc',
    borderRadius: 10,
    padding: 14,
    marginBottom: 4,
  },
  titleRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 6,
    alignItems: 'flex-start',
  },
  itemTitle: {
    fontWeight: '700',
    fontSize: 13,
    textTransform: 'uppercase',
    letterSpacing: 0.3,
  },
  downloadBtn: {
    backgroundColor: '#06b6d4',
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 8,
  },
  downloadBtnText: {
    color: 'white',
    fontWeight: '600',
  },
  'title-system': {
    color: '#3b82f6',
  },
  'title-tenant': {
    color: '#8b5cf6',
  },
  'title-payment': {
    color: '#10b981',
  },
  'title-document': {
    color: '#f59e0b',
  },
  'title-notification': {
    color: '#ef4444',
  },
  timeContainer: {
    backgroundColor: '#e0f2fe',
    borderRadius: 4,
    paddingVertical: 2,
    paddingHorizontal: 6,
  },
  time: {
    fontSize: 12,
    fontWeight: '600',
    color: '#0ea5e9',
  },
  description: {
    fontSize: 14,
    color: '#334155',
    marginBottom: 8,
    lineHeight: 20,
  },
  metaRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap',
  },
  avatar: {
    width: 26,
    height: 26,
    borderRadius: 13,
    backgroundColor: '#dbeafe',
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatarText: {
    fontSize: 11,
    fontWeight: '700',
    color: '#3b82f6',
  },
  user: {
    color: '#475569',
    fontWeight: '500',
    fontSize: 13,
  },
  date: {
    fontSize: 12,
    color: '#94a3b8',
    fontWeight: '500',
    marginLeft: 'auto',
  },
  loadMoreContainer: {
    alignItems: 'center',
    marginTop: 8,
    padding: 8,
  },
  loadMore: {
    textAlign: 'center',
    color: '#3b82f6',
    fontWeight: '600',
    fontSize: 14,
  },
  NoloadMore: {
    textAlign: 'center',

    fontWeight: '600',
    fontSize: 14,
    marginTop:100
  },
});

export default ActivityTimelineModal;